export default "/_next/static/images/16/searchDesktop-16d2658a73c203a391d50daafae31ec2.jpg";